import { render, staticRenderFns } from "./_fileConfigModal.vue?vue&type=template&id=4735dfd9"
import script from "./_fileConfigModal.vue?vue&type=script&lang=js"
export * from "./_fileConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports